import { post, get, put, patch, remove } from "../../ApiService";
import { ApiUrl, getUrl } from "../../ApiUrl";
const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

export const getDataSiteList = async (project: any) => {
  try {
    const res = await get(`${ApiUrl.siteManagement.getSiteList}`, { project });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getDataSiteVehicleTypes = async (
  project: any,
  page = 1,
  pageSize = 50
) => {
  try {
    const res = await get(`${ApiUrl.siteManagement.getSiteVehicles}`, {
      project,
      page,
      pageSize,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getProjectEnabledVehicleTypes = async (
  project: any,
  page = 1,
  pageSize = 50
) => {
  try {
    const res = await get(`${ApiUrl.booking.vehicleTypes}`, { project, page, page_size: pageSize });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getDataAccessPointList = async (
  project: any,
  site: any,
  is_active?: any,
  page: number = 1,
  pageSize: number = 50
) => {
  try {
    const res = await get(
      `${getUrl(ApiUrl.siteManagement.getSite, "/access-points/", site)}`,
      { page, pageSize, project, is_active }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getAddContactList = async (
  project: any,
  site: any,
  is_active: true
) => {
  try {
    const res = await get(
      `${getUrl(ApiUrl.siteManagement.getSite, "/contacts/", site)}?`,
      { project, is_active }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const addAccessPoint = async (data: any, project: any, site: any) => {
  try {
    const res = await post(
      `${getUrl(ApiUrl.siteManagement.getSite, "/access-points/", site)}`,
      data,
      { project }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const addContact = async (
  data: any,
  project: any,
  site: any,
  is_active: any
) => {
  try {
    const res = await post(
      `${getUrl(ApiUrl.siteManagement.getSite, "/contacts/", site)}`,
      data,
      { project, is_active }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const editContact = async (
  data: any,
  project: any,
  id: any,
  site: any
) => {
  try {
    const res = await put(
      `${getUrl(ApiUrl.siteManagement.getSite, "/contacts/", site)}${id}`,
      data,
      { project }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const editAccessPoint = async (
  data: any,
  project: any,
  site: any,
  id: any
) => {
  try {
    const res = await put(
      `${getUrl(ApiUrl.siteManagement.getSite, "/access-points/", site)}${id}/`,
      data,
      { project }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const batchUpdateAccessPoint = async (
  data: any[],
  project: any,
  site: any
) => {
  try {
    const res = await put(
      `${getUrl(
        ApiUrl.siteManagement.getSite,
        "/access-points/batch-update/",
        site
      )}`,
      data,
      { project }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const removeContact = async (project: any, site: any, id: any) => {
  try {
    const res = await remove(
      `${getUrl(ApiUrl.siteManagement.getSite, "/contacts/", site)}${id}`,
      { project }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const removeAccessPoint = async (
  project: any,
  site_id: any,
  id: any
) => {
  try {
    const res = await remove(
      `${getUrl(
        ApiUrl.siteManagement.getSite,
        "/access-points/",
        site_id
      )}${id}`,
      { project, site_id }
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const getSiteDetailData = async (project: any) => {
  try {
    const res = await get(`${ApiUrl.siteManagement.getSiteDetail}`, {
      project,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const addProjectDetail = async (body: any, project: any) => {
  try {
    const res = await patch(`${ApiUrl.siteManagement.getSiteDetail}`, body, {
      project,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const getTimeZone = async (latitude: number, longitude: number) => {
  try {
    const res = get(
      `${ApiUrl.googleAPI.getTimeZone}?location=${latitude}%2C${longitude}&timestamp=1331161200&key=${API_KEY}`
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const getLatLongFromAddress = async (address: string) => {
  try {
    const res = get(
      `${ApiUrl.googleAPI.getGeoCode}?address=${address}&libraries=places&key=${API_KEY}`
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getVehicleRestrictions = async (
  project: any,
  site: any,
  accessPointId: any
) => {
  try {
    // Construct the URL directly without using getUrl
    const url = `${ApiUrl.siteManagement.getSite}${site}/access-points/${accessPointId}/vehicle_restrictions/`;    
    // Only pass project as a query parameter
    const res = await get(url, { project });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const createVehicleRestriction = async (
  project: any,
  site: any,
  accessPointId: any,
  data: any
) => {
  try {
    // Construct the URL directly without using getUrl
    const url = `${ApiUrl.siteManagement.getSite}${site}/access-points/${accessPointId}/vehicle_restrictions_create/`;
    
    // Only pass project as a query parameter
    const res = await post(url, data, { project });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateVehicleRestriction = async (
  project: any,
  site: any,
  accessPointId: any,
  data: any
) => {
  try {
    // Construct the URL directly without using getUrl
    const url = `${ApiUrl.siteManagement.getSite}${site}/access-points/${accessPointId}/vehicle_restrictions_update/`;
    
    // Only pass project as a query parameter
    const res = await put(url, data, { project });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const deleteVehicleRestriction = async (
  project: any,
  site: any,
  accessPointId: any,
  restrictionId: any
) => {
  try {
    // Construct the URL directly without using getUrl
    const url = `${ApiUrl.siteManagement.getSite}${site}/access-points/${accessPointId}/vehicle_restrictions_delete/`;
    
    // Pass project and restriction_id as query parameters
    const res = await remove(url, { project, restriction_id: restrictionId });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

// Keep for backward compatibility
export const toggleVehicleRestriction = async (
  project: any,
  site: any,
  accessPointId: any,
  data: any
) => {
  try {
    // Construct the URL directly without using getUrl
    const url = `${ApiUrl.siteManagement.getSite}${site}/access-points/${accessPointId}/toggle_vehicle_restriction/`;
    // Only pass project as a query parameter
    const res = await post(url, data, { project });
    return res;
  } catch (error: any) {
    return error.response;
  }
};
